import ReactMarkdown, { Components } from 'react-markdown';
import { PluggableList } from 'react-markdown/lib/react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import CustomLinkRenderer from './CustomLinkRenderer';

type Props = {
  className?: string;
  components?: Components;
  children: string;
  rehypePlugins?: PluggableList;
  remarkPlugins?: PluggableList;
};

const Markdown = ({
  className,
  components,
  children,
  rehypePlugins = [],
  remarkPlugins = [],
}: Props) => {
  return (
    <ReactMarkdown
      // line break is correctly handled by the space-y-4 class
      className={`space-y-4 ${className}`}
      rehypePlugins={[rehypeRaw, ...rehypePlugins]}
      remarkPlugins={[remarkGfm, ...remarkPlugins]}
      components={{
        a: CustomLinkRenderer,
        ...components,
      }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default Markdown;
